import { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetBank/Main";
import Form from "./TbSetBank/Form";

// Utils
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

const TbSetBank = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก View_Set_Bank ทั้งหมด
      const masterList = await getDataWithComp("View_Set_Bank", "ORDER BY Bank_Id");

      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      Bank_Id: item.Bank_Id,
      Bank_Name_TH: item.Bank_Name_TH,
      Bank_Name_EN: item.Bank_Name_EN,
      Bank_Status: item.Bank_Status,
      Bank_Account: item.Bank_Account,
      Bank_Type: item.Bank_Type,
      Comp_Id: item.Comp_Id,
      APAR_Type: item.APAR_Type,
      APAR_Id: item.APAR_Id
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลธนาคาร"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลธนาคาร"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  masterList={dataMasterList}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetBank;
